<template>
  <div class="page">
    <BookingBack title="Profile Avatar" :textColor="'#333333'" :isCenter="true" />
    <div class="content">
      <div class="avatar-box">
        <van-image v-if="preview" :src="preview" width="9.375rem" height="9.375rem" />
        <div v-else class="avatar-holder" />
      </div>
      <van-uploader ref="uploader" :after-read="onRead" :max-count="1" :show-upload="false" />
      <van-button size="small" plain type="primary" class="change-btn" @click="triggerUpload">Change Avatar</van-button>
    </div>
    <div class="footer">
      <van-button block color="#1E3C3E" :loading="saving" @click="save">Save</van-button>
    </div>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { getUserDetail, uploadFile, updateUserInfo } from '@/api'
import myMixin from '@/utils/myMixin'
export default {
  name: 'AccountAvatar',
  components: { BookingBack },
  mixins: [myMixin],
  data() {
    return {
      preview: '',
      // 已上传到服务器的远端 URL；只有这种 URL 才能提交给 updateUserInfo
      uploadedUrl: '',
      user: {},
      uploading: false,
      saving: false
    }
  },
  created() {
    const q = this.$route.query || {}
    if (q.avatar) {
      this.preview = q.avatar
      this.uploadedUrl = q.avatar
    }
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const res = await getUserDetail()
        if (res && res.code === 1 && res.data && res.data.userInfo) {
          this.user = res.data.userInfo
          if (!this.preview) {
            this.preview = this.user.avatarUrl || ''
            this.uploadedUrl = this.user.avatarUrl || ''
          }
        }
      } catch (e) {}
    },
    triggerUpload() {
      this.$refs.uploader && this.$refs.uploader.chooseFile()
    },
    async onRead(file) {
      // 先用本地 dataURL 预览
      this.preview = file.content || ''
      // 立即上传到服务器，拿到可提交的远端地址
      this.uploading = true
      try {
        this.$toast && this.$toast.loading({ message: 'Uploading...', forbidClick: true })
        const fd = new FormData()
        fd.append('iFile', file.file, file.file.name)
        const res = await uploadFile(fd)
        if (res && res.code === 1 && res.data) {
          const url = this.getUrl(res.data.file_path)
          if (url) {
            this.uploadedUrl = url
            this.preview = url
            this.$toast && this.$toast.clear()
          } else {
            this.$toast && this.$toast.fail('Failed to get image URL')
          }
        } else {
          this.$toast && this.$toast.fail((res && res.msg) || 'Upload failed')
        }
      } catch (e) {
        this.$toast && this.$toast.fail('Upload failed')
      } finally {
        this.uploading = false
      }
    },
    async save() {
      if (this.uploading) {
        this.$toast && this.$toast('Uploading, please wait')
        return
      }
      if (!this.uploadedUrl) {
        this.$toast && this.$toast('Please choose an image first')
        return
      }
      this.saving = true
      try {
        const res = await updateUserInfo({
          avatarUrl: this.uploadedUrl,
          nickName: this.user.nickName || '',
          email: this.user.email || ''
        })
        if (res && res.code === 1) {
          this.$toast && this.$toast.success('Saved')
          this.$router.go(-1)
        } else {
          this.$toast && this.$toast.fail((res && res.msg) || 'Update failed')
        }
      } catch (e) {
        this.$toast && this.$toast.fail('Update failed')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page { min-height: 100vh; background: #f5f7fa; }
.content {
  display: flex; flex-direction: column; align-items: center; padding: 2rem 1rem 5rem;
}
.avatar-box { margin: 1rem 0; }
.avatar-holder {
  width: 9.375rem; height: 9.375rem; background: #d8d8d8; border-radius: .25rem;
}
.change-btn { margin-top: .5rem; }
.footer { position: fixed; left: 0; right: 0; bottom: 1rem; padding: 0 1rem; }
</style>
